var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.canShowList
    ? _c(
        "button",
        {
          staticClass: "btn btn-xs btn-outline",
          attrs: { disabled: _vm.isTrashed },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.showList.apply(null, arguments)
            },
          },
        },
        [_c("i", { staticClass: "fas fa-list" })]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }